module.exports = __webpack_public_path__ + "img/ax.6cc88fd4.svg";